$(function(){
	var voucherTabs = $('.product-voucher-tabs .tab'),
		voucherVariants = $('.product-voucher-variants .variant');
	$(window).resize(function(){
		var h = 0;
		voucherTabs.css('height','auto');
		voucherTabs.each(function(i){
			if($(this).outerHeight() > h){
				h = $(this).outerHeight();
			}
			if(i == 1){
				voucherTabs.css('height',h);
			}
		});
	}).resize();
	voucherTabs.click(function(){
		$(this).addClass('active').siblings('.tab').removeClass('active');
		voucherVariants.hide();
		voucherVariants.eq($(this).index()).show();
	});
	voucherTabs.first().click();
});